import React, { useEffect, useState } from "react";
import { Table } from "reactstrap";
import "../../assets/css/Profile.css";
import Heart from "../../assets/Profile/Heart.svg";
import "../../assets/css/tableRoundHeader.css";
import { getAllTasks } from "../../API/TaskApi";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import ClientHeader from "../../components/ClientHeader";
import { useLoggedInUser } from "../../config/zStore";

import { buildFilterPredicate, matchesPerson } from "../../utils/filterPredicate";

import { taskStatus, formatDelay } from "../../utils/taskStatus";
// Filter headings -> how each selection matches a task. Replaces an eval()'d
// string; see utils/filterPredicate.js for why (QA finding TASK-04).
const TASK_FILTER_MATCHERS = {
  "Assign By": (task, selection) => matchesPerson(task.assignBy, selection),
  "Assign To": (task, selection) => matchesPerson(task.assignTo, selection),
};

function Reports(props) {
  const navigate = useNavigate();
  const [allTasks, setAllTasks] = useState(null);
  const [tasksToShow, setTasksToShow] = useState(null);
  const {userData : currentUser} = useLoggedInUser()
  const [filterBy, setFilterBy] = useState(null);

  const [page, setPage] = useState(2);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [filterCondition, setFilterCondition] = useState(null);

  const getTaskData = async () => {
    try {
      const tasks = await getAllTasks(1);
      setAllTasks(tasks);
      setTasksToShow(tasks)
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (
      currentUser?.rollSelect === "Editor" ||
      currentUser?.rollSelect === "Shooter"
    ) {
      navigate("/MyProfile/Tasks/DailyTasks");
    }
    getTaskData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchTasks = async () => {
    if (hasMore) {
      setLoading(true);
      try {
        
        const  data = await getAllTasks(page);
         
        
        if (data.length > 0) {
          let dataToAdd;
         
            setAllTasks([...allTasks, ...data])
            if(filterCondition){
              dataToAdd = data.filter(filterCondition)
            } else {
              dataToAdd = data
            }
            setTasksToShow([...tasksToShow, ...dataToAdd]);
          

          setPage(page + 1);
        } else {
          setHasMore(false);
        }
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    }
  };

  useEffect(()=>{
    if(tasksToShow?.length < 10 && hasMore && !loading){
      fetchTasks()
    }
  }, [tasksToShow])
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleScroll = () => {
    const bottomOfWindow =
      document.documentElement.scrollTop + window.innerHeight >=
      document.documentElement.scrollHeight - 10;

    if (bottomOfWindow) {
      console.log("at bottom");
      fetchTasks();
    }
  };

  // useEffect(() => {
  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [handleScroll]);

  const getUsersForFilters = (propertyName) => {
    const seenUsers = new Set();
    return allTasks
      ?.map((taskObj, i) => ({
        title: `${taskObj?.[propertyName]?.firstName}`,
        id: i,
        userId: taskObj?.[propertyName]?._id,
      }))
      .filter((taskObj) => {
        if (taskObj.userId && !seenUsers.has(taskObj.userId)) {
          seenUsers.add(taskObj.userId);
          return true;
        }
        return false;
      });
  };
  const filterOptions = [
    {
      title: "Assign By",
      id: 1,
      filters: getUsersForFilters("assignBy"),
    },
    {
      title: "Assign To",
      id: 2,
      filters: getUsersForFilters("assignTo"),
    },
  ];

  // Define priority for parentTitle
  const priority = {
    "Assign By": 1,
    "Assign To": 2,
  };

  const changeFilter = (filterType) => {
    if (filterType !== filterBy) {
      setTasksToShow(allTasks);
    }
    setFilterBy(filterType);
  };

  const applyFilterNew = (filterValue) => {
    const predicate = buildFilterPredicate(filterValue, TASK_FILTER_MATCHERS);
    // Clearing the filter must clear the condition used for later pages too,
    // or a cleared filter keeps applying to everything loaded after it
    // (TASK-05). A function passed to a state setter is treated as an
    // updater, hence the wrapper.
    setFilterCondition(() => predicate);
    setTasksToShow(predicate ? allTasks.filter(predicate) : allTasks);
  };


  useEffect(() => {
    // Select the .table-responsive element
    const tableResponsiveElement = document.querySelector(".table-responsive");
    // Apply the max-height style
    if (tableResponsiveElement) {
      tableResponsiveElement.style.maxHeight = "75vh";
      tableResponsiveElement.style.overflowY = "auto";
    }

    // Clean up style when the component unmounts
    return () => {
      if (tableResponsiveElement) {
        tableResponsiveElement.style.maxHeight = "";
        tableResponsiveElement.style.overflowY = "";
      }
    };
  }, [document.querySelector(".table-responsive")]);
  return (
    <>
      <ClientHeader
        selectFilter={changeFilter}
        currentFilter={filterBy}
        priority={priority} applyFilter={applyFilterNew}
        options={filterOptions}
        title="Tasks Reports"
        filter
      />
      {tasksToShow ? (
         <>
        <Table
          bordered
          hover
          borderless
          responsive
          // striped
          className="tableViewClient"
          style={{ width: "130%", marginTop: "15px" }}
        >
          <thead  style={{ position: "sticky", top: 0, zIndex: 101 }} >
            <tr className="logsHeader Text16N1">
              <th className="tableBody">Client</th>
              <th className="tableBody">Task</th>
              <th className="tableBody">Task Assigned Date</th>
              <th className="tableBody">Assigned By</th>
              <th className="tableBody">Assigned To</th>
              <th className="tableBody">Status</th>
              <th className="tableBody">Deadline</th>
              <th className="tableBody">Completion Date</th>
              <th className="tableBody">Task Ended</th>
              <th className="tableBody">Delays</th>
            </tr>
          </thead>
          <tbody
            className="Text12"
            style={{
              textAlign: "center",
              borderWidth: '1px 1px 1px 1px',
              // background: "#EFF0F5",
            }}
          >
            {tasksToShow?.map((task, index) => (
              <React.Fragment key={task?._id ?? index}>
                <tr aria-hidden="true" style={{ height: "15px" }} />
                <tr
                  style={{
                    background: "#EFF0F5",
                    borderRadius: "8px",
                  }}
                >
                  <td
                    className="tableBody Text14Semi primary2 tablePlaceContent"
                    style={{
                      paddingTop: "15px",
                      paddingBottom: "15px",
                    }}
                  >
                    {task?.client.brideName}
                    <br />
                    <img src={Heart} alt="" />
                    <br />
                    {task?.client?.groomName}
                  </td>

                  <td
                    className="tableBody Text14Semi primary2 tablePlaceContent"
                    style={{
                      paddingTop: "15px",
                      paddingBottom: "15px",
                    }}
                  >
                    {task.taskName}
                  </td>
                  <td
                    className="tableBody Text14Semi primary2 tablePlaceContent"
                    style={{
                      paddingTop: "15px",
                      paddingBottom: "15px",
                    }}
                  >
                    {dayjs(task.assignDate).format("DD-MMM-YYYY")}
                  </td>
                  <td
                    className="tableBody Text14Semi primary2 tablePlaceContent"
                    style={{
                      paddingTop: "15px",
                      paddingBottom: "15px",
                    }}
                  >
                    {task.assignBy.firstName} {task.assignBy.lastName}
                  </td>
                  <td
                    className="tableBody Text14Semi primary2 tablePlaceContent"
                    style={{
                      paddingTop: "15px",
                      paddingBottom: "15px",
                    }}
                  >
                    {task.assignTo.firstName} {task.assignTo.lastName}
                  </td>
                  <td
                    className="tableBody Text14Semi primary2 tablePlaceContent"
                    style={{
                      paddingTop: "15px",
                      paddingBottom: "15px",
                    }}
                  >
                    {taskStatus(task)}
                  </td>
                  <td
                    className="tableBody Text14Semi primary2 tablePlaceContent"
                    style={{
                      paddingTop: "15px",
                      paddingBottom: "15px",
                    }}
                  >
                    {dayjs(task.deadlineDate).format("DD-MMM-YYYY")}
                  </td>
                  <td
                    className="tableBody Text14Semi primary2 tablePlaceContent"
                    style={{
                      paddingTop: "15px",
                      paddingBottom: "15px",
                    }}
                  >
                    {task.completionDate
                      ? dayjs(task.completionDate).format("DD-MMM-YYYY")
                      : "Not Yet Completed"}
                  </td>
                  <td
                    className="tableBody Text14Semi primary2 tablePlaceContent"
                    style={{
                      paddingTop: "15px",
                      paddingBottom: "15px",
                    }}
                  >
                    {task.ended ? "Yes" : "No"}
                  </td>
                  <td
                    className="tableBody Text14Semi primary2 tablePlaceContent"
                    style={{
                      paddingTop: "15px",
                      paddingBottom: "15px",
                    }}
                  >
                    {formatDelay(task)}
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </Table>
       
         {loading && (
           <div className="d-flex my-3 justify-content-center align-items-center">
            <div className="spinner"></div>
          </div>
        )}
        {!hasMore && (
          <div className="d-flex my-3 justify-content-center align-items-center">
            <div>No more data to load.</div>
          </div>
        )}
        {(!loading && hasMore) && (
              <div className="d-flex my-3 justify-content-center align-items-center">
                <button
                  onClick={() => fetchTasks()}
                  className="btn btn-primary"
                  style={{ backgroundColor: "#666DFF", marginLeft: "5px" }}
                >
                  Load More
                </button>
              </div>
            )}
        </>
      ) : (
        <div
          style={{ height: "400px" }}
          className="d-flex justify-content-center align-items-center"
        >
          <div className="spinner"></div>
        </div>
      )}
    </>
  );
}

export default Reports;
